import {
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_ERROR,
  CREATE_NEW_ROLE,
  NEW_ROLE_SUCCESS,
  NEW_ROLE_ERROR,
  MODIFY_ROLE,
  MODIFY_ROLE_SUCCESS,
  MODIFY_ROLE_ERROR,
  DELETE_ROLE,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  ASSIGN_ROLE,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_ERROR,
  REMOVE_ASSIGNEE,
  REMOVE_ASSIGNEE_SUCCESS,
  REMOVE_ASSIGNEE_ERROR,
  DUPLICATE_ROLE,
  SET_CURRENT_ROLE_PERMISSIONS_UI_STATE,
} from "./actionTypes"

export const getRoles = account => {
  return {
    type: GET_ROLES,
    payload: account,
  }
}

export const getRolesSuccess = roles => {
  return {
    type: GET_ROLES_SUCCESS,
    payload: roles,
  }
}

export const getRolesError = error => {
  return {
    type: GET_ROLES_ERROR,
    payload: error,
  }
}

export const createNewRole = (role, history) => {
  return {
    type: CREATE_NEW_ROLE,
    payload: { role, history },
  }
}

export const newRoleSuccess = role => {
  return {
    type: NEW_ROLE_SUCCESS,
    payload: role,
  }
}

export const duplicateRole = role => {
  return {
    type: DUPLICATE_ROLE,
    payload: role,
  }
}

export const newRoleError = error => {
  return {
    type: NEW_ROLE_ERROR,
    payload: error,
  }
}

export const modifyRole = (role, history) => {
  return {
    type: MODIFY_ROLE,
    payload: { role, history },
  }
}

export const modifyRoleSuccess = role => {
  return {
    type: MODIFY_ROLE_SUCCESS,
    payload: role,
  }
}

export const modifyRoleError = error => {
  return {
    type: MODIFY_ROLE_ERROR,
    payload: error,
  }
}

export const deleteRole = role => {
  return {
    type: DELETE_ROLE,
    payload: role,
  }
}

export const deleteRoleSuccess = role => {
  return {
    type: DELETE_ROLE_SUCCESS,
    payload: role,
  }
}

export const deleteRoleError = error => {
  return {
    type: DELETE_ROLE_ERROR,
    payload: error,
  }
}

export const assignRole = (user, role, history) => {
  return {
    type: ASSIGN_ROLE,
    payload: { user, role, history },
  }
}

export const assignRoleSuccess = (user, role) => {
  return {
    type: ASSIGN_ROLE_SUCCESS,
    payload: { user, role },
  }
}

export const assignRoleError = error => {
  return {
    type: ASSIGN_ROLE_ERROR,
    payload: error,
  }
}

export const removeAssignee = (user, role, history) => {
  return {
    type: REMOVE_ASSIGNEE,
    payload: { user, role, history },
  }
}

export const removeAssigneeSuccess = (user, role) => {
  return {
    type: REMOVE_ASSIGNEE_SUCCESS,
    payload: { user, role },
  }
}

export const removeAssigneeError = error => {
  return {
    type: REMOVE_ASSIGNEE_ERROR,
    payload: error,
  }
}

export const setCurrentRolePermissionsUIState = rolePermissionsUIState => {
  return {
    type: SET_CURRENT_ROLE_PERMISSIONS_UI_STATE,
    payload: rolePermissionsUIState
  }
}
